export default __webpack_public_path__ + "static/media/vectorRD.22ed7ec9.svg";